import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Icon } from "@iconify/react";
import { DefaultNavigateInterface } from "../../interface/navigation.interface";
import { useTranslation } from "react-i18next";

function DefaultNavigation({
  title,
  menu,
}: DefaultNavigateInterface) {
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);

  const { t, i18n } = useTranslation("menu");

  console.log("Current language:", i18n.language);
  console.log("Menu:", menu);
  console.log("Translation test:", t("home"));

  return (
    <nav
      role="navigation"
      aria-label={`${t(title)} navigation`}
      className="
        bg-transparent lg:bg-dark_grey text-white
        flex flex-col md:flex-row
        items-center justify-start rounded-lg
        transition-all duration-300 mx-auto
      "
    >
      {/* Title */}
      <div className="text-primary lg:hidden text-lg font-semibold md:ms-5">
        {t(title)}
      </div>

      {/* Mobile Toggle */}
      <button
        type="button"
        className="lg:hidden text-white"
        aria-label="Toggle navigation menu"
        aria-expanded={mobileOpen}
        aria-controls="mobile-menu"
        onClick={() => setMobileOpen((prev) => !prev)}
      >
        <Icon
          icon="ic:baseline-apps"
          width="32"
          height="32"
        />
      </button>

      {/* Mobile Menu */}
      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => setMobileOpen(false)}
          />

          <div
            id="mobile-menu"
            role="menu"
            className="
              fixed top-0 left-0 h-full w-64
              bg-dark_grey z-50
              transform transition-transform
              duration-300 ease-in-out
              translate-x-0
            "
          >
            {/* Header */}
            <div className="p-4 flex justify-between items-center border-b border-gray-700">
              <span className="text-primary font-semibold">
                {t(title)}
              </span>

              <button
                type="button"
                onClick={() => setMobileOpen(false)}
                aria-label="Close navigation menu"
              >
                ✕
              </button>
            </div>

            {/* Menu Items */}
            <ul className="flex flex-col p-4 space-y-2">
              {menu?.map((item, index) => {
                if (!item.show) {
                  return null;
                }

                const isActive =
                  location.pathname === item.href;

                return (
                  <li key={index}>
                    <Link
                      to={item.href}
                      onClick={() => setMobileOpen(false)}
                      className={`block py-2 px-3 rounded ${
                        isActive
                          ? "text-primary font-semibold"
                          : "hover:text-primary"
                      }`}
                    >
                      {t(item.label)}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}

      {/* Desktop Menu */}
      <ul
        role="menubar"
        className="
          shop-tab-nav
          lg:flex flex-col md:flex-row
          md:items-center
          w-full md:w-auto
          hidden
          md:static md:mt-0
          py-3
          overflow-hidden
          flex-wrap
          mx-auto
        "
      >
        {menu?.map((item, index) => {
          if (!item.show) {
            return null;
          }

          const isActive =
            location.pathname === item.href;

          return (
            <li
              key={index}
              role="none"
              className="md:mx-2 mb-2 md:mb-0"
            >
              <Link
                to={item.href}
                role="menuitem"
                aria-label={`Navigate to ${t(item.label)}`}
                aria-current={
                  isActive ? "page" : undefined
                }
                className={`text-sm inline-block py-2 px-2 ${
                  isActive
                    ? "text-primary font-semibold"
                    : "hover:text-primary text-white"
                }`}
              >
                {t(item.label)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default DefaultNavigation;
